import React, { useRef, useState, useEffect } from "react";
import Sidebar from "../../components/sidebar";
import { useAccelerators } from "../../hooks/useAccelerators";
import PageLoader from "../../components/loader/loader";
import TrainingHeader from "../../components/headers/training";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import SubNavigation from "../../components/subNavigation";
import { FilterMobileModal } from "../../components/dialogs/filterMobileModal";
import HeaderTrainingMobile from "../../components/headers/trainingMobile";
import TrainingCardCarousel from "../../components/cards/trainingCards/trainingCardCarousel";
import { netflixTrainingProgramViewed, pageViewEvent } from "../../components/mixPanelEvents/mixPanelEvents";
import useHighlightCurrentMenuItem from "../../hooks/useHighlightCurrentMenuItem";
import ScratchClubHeader from "../../components/headers/scratchClub/scratchClubHeader";

function ScCatalog() {

  const [
    filterData,
    loaded,
    courses,
    handleFilterTypeCheckboxChange,
    handleFilterCheckboxChange,
    selectedFilters,
    handleResetFilter,
    handleMobileFilterChange,
    popularCourses,
    recomendedCourses,
    handleFilterCheckboxChangeOnMobile,
  ] = useAccelerators();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));

  useHighlightCurrentMenuItem('/scratch-club')

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [offsetWidth, setOffsetWidth] = useState<number>(0);
 



  const updateContainerWidth = () => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  };
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        updateContainerWidth(); // Call the function to update container width
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
      updateContainerWidth(); // Call the function to update container width initially
    }

    return () => {
      observer.disconnect();
    };
  }, [containerRef.current]);

  useEffect(() => {
    console.log("Offset width changed:", offsetWidth); // Log offsetWidth changes
    // Trigger the useEffect whenever the offsetWidth changes
    setTimeout(() => {
      updateContainerWidth(); // Call the function to update container width
    }, 1000);
  }, [offsetWidth]);

  const handleSidebarToggle = () => {
    setSidebarOpen(!isSidebarOpen);
    setIsMobileFilterOpen(!isSidebarOpen);
  };

  const handleMobileFilterToggle = () => {
    setSidebarOpen((prev) => !prev)
    setIsMobileFilterOpen((prev) => !prev);
  };

  useEffect(() => {
    pageViewEvent('Practice')
}, [loaded]);

  return (
    <>
    {(!isMobile || (isMobile && !isMobileFilterOpen)) && <ScratchClubHeader />}
      {!loaded && <PageLoader />}
      {isMobile && isMobileFilterOpen && (
        <FilterMobileModal
          handleMobileFilterChange={handleMobileFilterChange}
          handleResetFilter={handleResetFilter}
          onFilterChange={handleFilterCheckboxChangeOnMobile}
          onFilterTypeChange={handleFilterTypeCheckboxChange}
          selectedFilters={selectedFilters}
          filterData={filterData}
          handleMobileFilterToggle={handleMobileFilterToggle}
        />
      )}
      {loaded && filterData && (

        <Box
          id={"mainBox"}
          sx={{
            padding: isMobile ? "0 13px" : isSidebarOpen ? "0px" : "0 0",
            overflow: "hidden",
            margin: "0 auto",
          }}
          className="maxWidthOverflow"
        >
         {(!isMobile || !isMobileFilterOpen) && (
          <TrainingHeader
            onFilterChange={handleFilterCheckboxChange}
            selectedFilters={selectedFilters}
            handleSidebarToggle={handleSidebarToggle}
            isSidebarOpen={isSidebarOpen}
            source="SC"
            filterData={filterData}
          />
        )}
          {/* )} */}
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              paddingBottom: isMobile ? "10px" : "20px",
            }}
            className="mainCoursesContainerMaster"
          >
            {!isMobile && (
              <Sidebar
                handleResetFilter={handleResetFilter}
                selectedFilters={selectedFilters}
                onFilterChange={handleFilterCheckboxChange}
                onFilterTypeChange={handleFilterTypeCheckboxChange}
                filterData={filterData}
                handleSidebarToggle={handleSidebarToggle}
                isSidebarOpen={isSidebarOpen}
                isSC={true}
              />
            )}

            <div
              className={isMobileFilterOpen ? "mobileFilterOpenedCorrection": "mobileFilterClosedCorrection" } 
              >
              {isMobile && (
                <HeaderTrainingMobile
                  selectedFilters={selectedFilters}
                  handleMobileFilterToggle={handleMobileFilterToggle}
                  filterData={filterData}
                  onFilterChange={handleFilterCheckboxChangeOnMobile}
                  handleResetFilter={handleResetFilter}
                />
              )}
              <Box
                ref={containerRef}
                style={{
                  width: "100%",
                  background: "#fff",
                  paddingTop: "15px",
                  overflow: "hidden",
                }}
                sx={{
                  height: isMobile && courses.length >= 2 ? "1460px" : isMobile ? "800px" : "auto",
                }}
                className={isSidebarOpen ? "mainCoursesContainer isSidebarOpen" : "mainCoursesContainer"}
              >
                {courses.map((course, index) => (
                  course.things.length > 0 && (
                    <div
                      key={index}
                      className={
                        course.things.length > 0
                          ? "carouselAndTitleAndArrowsContainer"
                          : ""
                      }
                    >
                      {course.things.length > 0 && (
                        <div className="coursesTrainingCarousel">
                          <TrainingCardCarousel
                            items={course.things}
                            width={containerWidth}
                            carouselTitle={course.name}
                            parentPage={"course"}
                            isSidebarOpen={isSidebarOpen}
                            locationValue="Scratch Club"
                          />
                        </div>
                      )}
                    </div>)
                ))}
              </Box>
            </div>
          </Box>
        </Box>
      )}
    </>
  );
}
export default ScCatalog;
